export var ICarouselStyle;
(function (ICarouselStyle) {
    let CarouselTransitionStyle;
    (function (CarouselTransitionStyle) {
        CarouselTransitionStyle["CAROUSEL_TRANSITION_STYLE_UNKNOWN"] = "CAROUSEL_TRANSITION_STYLE_UNKNOWN";
        /**
         * SNAP in desktop, SCROLL in mobile
         */
        CarouselTransitionStyle["DEFAULT_CAROUSEL_TRANSITION_STYLE"] = "DEFAULT_CAROUSEL_TRANSITION_STYLE";
        /**
         * For the SNAP behaviour, when the user drags a slide to transition, the carousel will adjust the slide
         * such that the first tile in the slide aligns to the left edge of the tile container
         */
        CarouselTransitionStyle["SNAP"] = "SNAP";
        /**
         * For the SCROLL behaviour, when the user drags a slide to transition, the carousel will act as though it is a
         * horizontal scrollable container and not attempt to align the slides within the tile container
         */
        CarouselTransitionStyle["SCROLL"] = "SCROLL";
    })(CarouselTransitionStyle = ICarouselStyle.CarouselTransitionStyle || (ICarouselStyle.CarouselTransitionStyle = {}));
    let NavigationControl;
    (function (NavigationControl) {
        NavigationControl["NAVIGATION_CONTROL_UNKNOWN"] = "NAVIGATION_CONTROL_UNKNOWN";
        /**
         * For the NO_CONTROLS behaviour, no navigation controls will be shown and the user will only be able to
         * transition between slides using their pointer to drag a slide left or right
         */
        NavigationControl["NO_CONTROLS"] = "NO_CONTROLS";
        /**
         * For the ARROWS behaviour, navigation arrows will appear to the left and the right of the tile container
         * Upon interacting with the arrows, the carousel will transition to the previous or next slides. Upon transition,
         * the first tile of the target slide will be aligned left edge of the tile container.
         */
        NavigationControl["ARROWS"] = "ARROWS";
        /**
         * ARROWS with primary variant in desktop, NONE in mobile
         */
        NavigationControl["DEFAULT_PRIMARY_NAVIGATION_CONTROL"] = "DEFAULT_PRIMARY_NAVIGATION_CONTROL";
        /**
         * ARROWS with secondary variant in desktop, NONE in
         */
        NavigationControl["DEFAULT_SECONDARY_NAVIGATION_CONTROL"] = "DEFAULT_SECONDARY_NAVIGATION_CONTROL";
    })(NavigationControl = ICarouselStyle.NavigationControl || (ICarouselStyle.NavigationControl = {}));
    let LoopBehavior;
    (function (LoopBehavior) {
        LoopBehavior["LOOP_BEHAVIOR_UNKNOWN"] = "LOOP_BEHAVIOR_UNKNOWN";
        /**
         * INFINITE in desktop, NONE in mobile
         */
        LoopBehavior["DEFAULT_LOOP_BEHAVIOR"] = "DEFAULT_LOOP_BEHAVIOR";
        /**
         * For the NO_LOOP behaviour, when the user has transitioned through all slides to reach the last tile, the user
         * will no longer will able to drag or use navigation controls to view more slides. The last tile in the last slide
         * will be aligned to the right edge of the tile container
         */
        LoopBehavior["NO_LOOP"] = "NO_LOOP";
        /**
         * For the INFINITE behaviour, when the user has transitioned through all slides to reach the last tile, the user
         * will able to drag or use navigation control to continue navigation. If the last slide, does not have enough tile
         * to items per slide, the first N tiles from the first slide will be appending to the end of the last slide to
         * to create a virtual full slide of tiles. Transition to the next slide from the last virtual slide will transition
         * to the first slide. The creates the effect of always being able to transition to the next / previous slide
         */
        LoopBehavior["INFINITE"] = "INFINITE";
    })(LoopBehavior = ICarouselStyle.LoopBehavior || (ICarouselStyle.LoopBehavior = {}));
    let ITileWidth;
    (function (ITileWidth) {
        /**
         * Return an instance of ITileWidth with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        ITileWidth.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
    })(ITileWidth = ICarouselStyle.ITileWidth || (ICarouselStyle.ITileWidth = {}));
    let IFractionalTileWidth;
    (function (IFractionalTileWidth) {
        /**
         * Return an instance of IFractionalTileWidth with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        IFractionalTileWidth.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
    })(IFractionalTileWidth = ICarouselStyle.IFractionalTileWidth || (ICarouselStyle.IFractionalTileWidth = {}));
    /**
     * Return an instance of ICarouselStyle with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    ICarouselStyle.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
})(ICarouselStyle || (ICarouselStyle = {}));
